import request from "@/utils/request";
export function getLogin(url) {
  return request({
    url: `web/userLogin?` + url,
    method: "get"
  });
}

export function getuserScore(url) {
  return request({
    url: `userScore`,
    method: "get"
  });
}

// 写作批改 start
//查询code信息
export function getCorrectionStatus(id, codeTaskType) {
  return request({
    url: `web/correctionStatus?correctSubjectId=` + id + '&codeTaskType=' + codeTaskType,
    method: "get"
  });
}
// 写作批改 start
//查询code信息
export function getCorrectionStatus2(id, codeTaskType) {
  return request({
    url: `web/aiCorrectionStatus?correctSubjectId=` + id + '&codeTaskType=' + codeTaskType,
    method: "get"
  });
}
//提交code信息
export function putCorrectionStatus(data) {
  return request({
    url: `web/correctionStatus/activate`,
    method: "put",
    data
  });
}
//提交code信息
export function putCorrectionStatus2(data) {
  return request({
    url: `web/aiCorrectionStatus/activate`,
    method: "put",
    data
  });
}
//查询批改
export function getIeltsDeskmateWritingById(id) {
  return request({
    url: `web/ieltsDeskmateWritingById?id=${id}`,
    method: "get"
  });
}
// 写作批改 end

//查询雅思听力
export function getIeltsHearingList(id, history) {
  return request({
    url: `ieltsHearing/getIeltsHearingOne/` + id + `?history=` + history,
    method: "get"
  });
}
//清空雅思听力练习的答案
export function delIeltsHearingList(id) {
  return request({
    url: `ieltsHearing/getDeleteIeltsHearingTitleChild/` + id,
    method: "get"
  });
}
// 获取雅思列表
export function getieltsList(type) {
  return request({
    url: `ieltsHearing/getIeltsHearingList/${type}`,
    method: "get"
  });
}
// 按section获取雅思列表
export function getIeltsSectionList(type) {
  return request({
    url: `ieltsHearing/getIeltsHearingListBySection/${type}`,
    method: "get"
  });
}
// 按题型获取雅思列表
export function getIeltsTypeList(type) {
  return request({
    url: `ieltsHearing/getIeltsHearingListByQuestion/${type}`,
    method: "get"
  });
}
// 获取托福列表
export function gettoeflList(front, after) {
  return request({
    url: `toeflHearingText/official?front=${front}&after=${after}`,
    method: "get"
  });
}

//收藏雅思句子，1是句子 2是单词
export function postHearingCollection(id, data) {
  return request({
    url: `ieltsHearing/postIeltsHearingCollection/${id}`,
    method: "post",
    data
  });
}
//获取雅思阅读Test列表
export function getIeltsReading(type) {
  return request({
    url: `ieltsHearingAnalysis/getByType?type=${type}`,
    method: "GET"
  });
}
//按话题获取雅思阅读Test列表
export function getByTitleReading(title) {
  return request({
    url: `ieltsHearingAnalysis/getByTitle?title=${title}`,
    method: "GET"
  });
}
//按题型获取雅思阅读Test列表
export function getIeltsRead(title) {
  return request({
    url: `ieltsRead/${title}`,
    method: "GET"
  });
}

//获取雅思阅读详情页面
export function getIeltsReadingDetails(id, num) {
  if (num != 2) num = 1;
  return request({
    url: `ieltsHearingAnalysis/getById?id=${id}&difference=${num}`,
    method: "GET"
  });
}
//获取雅思阅读文章
export function getIeltsReadingText(id) {
  return request({
    url: `ieltsHearingAnalysis/getByIdText?id=${id}`,
    method: "GET"
  });
}
// 获取答案为空的数据
export function getieltsHearingAnswer2(data) {
  return request({
    url: `ieltsHearingAnswer2`,
    method: "POST",
    data
  });
}
// 删除前一次答题记录
export function deleteieltsHearingAnswer2(ids) {
  return request({
    url: `ieltsHearingAnswer2?id=${ids}`,
    method: "DELETE"
  });
}
// 雅思阅读清除答题记录
export function deleteIeltsDeskmateRead(ids) {
  return request({
    url: `web/student/ieltsDeskmateRead/${ids}`,
    method: "DELETE"
  });
}


//获取雅思阅单选填答案
export function postUploadAnswers(data) {
  return request({
    url: `ieltsHearingAnswer`,
    method: "POST",
    data
  });
}

//雅思精听获取id
export function startGetIeltsHearingList(type) {
  return request({
    url: `getIeltsHearingList/${type}`,
    method: "GET"
  });
}

//删除剑雅听力的句子收藏
export function delIeltsHearingCollectionWord(id) {
  return request({
    url: `ieltsHearing/getDelIeltsHearing/` + id,
    method: "GET"
  });
}

//删除雅思听力单词收藏
export function delIeltsHearingCollectionVocabulary(id) {
  return request({
    url: `ieltsHearing/getDeleteIeltsHearingCollection/` + id,
    method: "GET"
  });
}

//获取答题记录
// export function getIeltsHearingAnswer(id) {
//   return request({
//     url: `ieltsHearingAnswer?id=${id}`,
//     method: "GET"
//   });
// }
export function getIeltsHearingAnswer(id, num) {
  if (num && num != 2) num = 1;
  return request({
    url: `ieltsHearingAnswer?id=${id}${num ? "&difference=" + num : ""}`,
    method: "GET"
  });
}

//雅思获取答题记录
export function getIeltsHearingTitle(id, history) {
  return request({
    url: `ieltsHearing/getIeltsHearingTitle/${id}` + `?history=${history}`,
    method: "GET"
  });
}

//查听力收藏，1是句子 2是单词
export function getHearingCollection(id) {
  return request({
    url: `ieltsHearing/getIeltsHearingCollection/ieltsHearingListId?ieltsHearingListId=${id}`,
    method: "GET"
  });
}

//获取单词翻译
export function postGetWord(data) {
  return request({
    url: `ieltsHearing/getWord`,
    method: "POST",
    data
  });
}

//所有页面收藏单词
export function postIeltsHearingCollectionWord(data) {
  return request({
    url: `web/student/ieltsDeskmateCollect`,
    method: "POST",
    data
  });
}

//所有页面删除单词
export function delIeltsCollectionWord(id) {
  return request({
    url: `web/student/ieltsDeskmateCollect/${id}`,
    method: "DELETE"
  });
}

//查询雅思单词收藏状态
export function getHearingCollectionWord(word) {
  return request({
    url: `web/student/ieltsDeskmateCollectByWord?word=${word}`,
    method: "GET"
  });
}


//添加收藏单词
export function postieltsHearingCollection(data) {
  return request({
    url: `ieltsHearingCollection`,
    method: "POST",
    data
  });
}
//获取收藏单词列表
export function getieltsHearingCollection(id1) {
  return request({
    url: `ieltsHearingCollection?ieltsHearingAnalysisId=` + id1 * 1,
    method: "GET"
  });
}
//删除收藏单词
export function deleteieltsHearingCollection(
  ieltsHearingAnalysisId,
  studentWordId
) {
  return request({
    url: `ieltsHearingCollection?ieltsHearingAnalysisId=${ieltsHearingAnalysisId}&studentWordId=${studentWordId}`,
    method: "DELETE"
  });
}

// 听力题目做完提交
export function postIeltsHearingTitle(id, data) {
  return request({
    url: `ieltsHearing/postIeltsHearingTitle/${id}`,
    method: "POST",
    data
  });
}

//获取雅思听力收藏 1是句子 2单词
export function getIeltsHearingCollectionVocabulary(id) {
  return request({
    url: `ieltsHearing/getIeltsHearingCollection/` + id * 1,
    method: "GET"
  });
}

//获取指定的雅思听力
export function getIeltsHearingVocabulary(arr) {
  return request({
    url: `ieltsHearing/getIeltsHearingCollectionByIds?ids=${arr}`,
    method: "GET"
  });
}

//获取指定的收藏单词
export function getIeltsDeskmateCollectByIds(arr) {
  return request({
    url: `web/student/ieltsDeskmateCollectByIds?ids=${arr}`,
    method: "GET"
  });
}

// export function deleteieltsHearingCollection(ieltsHearingAnalysisId,studentWordId) {
//     return request({
//         url: `ieltsHearingCollection?ieltsHearingAnalysisId=${ieltsHearingAnalysisId}&studentWordId=${studentWordId}`,
//         method: 'DELETE',
//     })
// }

//重新答题
export function delIeltsHearingAnswer(ids) {
  return request({
    url: `ieltsHearingAnswer?ids=${ids}`,
    method: "DELETE"
  });
}

// 获取托福话题列表
export function getToeflTopicList(size) {
  return request({
    url: `toeflHearingText/conversation?size=${size}`,
    method: "get"
  });
}

//托福列表页面
export function getToeflRead(ids, size) {
  return request({
    url: `toeflReadList/practice?classification=${ids}&size=${size}`,
    method: "GET"
  });
}
//托福列表页面按条件筛选(新)
export function getClassify(ids, size ,subject) {
  return request({
    url: `toeflReadList/classify?classification=${ids}&size=${size}${subject !== null?"&subject="+subject:''}`,
    method: "GET"
  });
}
//按场景练习获取托福列表页面
export function getToeflReadScene(subject) {
  return request({
    url: `toeflReadList/scene?subject=${subject}`,
    method: "GET"
  });
}
//托福详情页面
export function getToeflReadDetails(id) {
  return request({
    url: `toeflReadList/${id}`,
    method: "GET"
  });
}
//托福填答案
export function postToeflReadAnswer(data) {
  console.log(data, "apidata");
  return request({
    url: `/toeflReadAnswer`,
    method: "POST",
    data
  });
}
//托福清除答题记录
export function deleteToeflReadAnswer(id) {
  return request({
    url: `/toeflReadAnswer/${id}`,
    method: "POST"
  });
}
//获取平均正确率
export function getToeflReadAnswerAccuracy(id, type, size) {
  size = size == undefined ? 0 : size;
  return request({
    url: `/toeflReadAnswer/${id}?type=${type}&size=${size}`,
    method: "GET"
  });
}
//上传反馈数据
export function postFeedbackQuestions(data) {
  return request({
    url: `/feedbackQuestions`,
    method: "POST",
    data
  });
}
//保存托福阅读继续做题的时间
export function toeflReadAnswerTime(data) {
  return request({
    url: `/toeflReadAnswer`,
    method: "POST",
    data
  });
}
//判断托福阅读是否已答完题
export function toeflReadAnswerAnswerAll(id) {
  return request({
    url: `/toeflReadAnswer/answerAll/${id}`,
    method: "GET"
  });
}
//查询托福听力
export function getToeflHearingList(id) {
  return request({
    url: `toeflHearingText/` + id,
    method: "get"
  });
}

//托福听力获取解析
export function GetToeflHearingPractice(id) {
  return request({
    url: `toeflPractice2/${id}`,
    method: "GET"
  });
}

//托福听力获取解析,回顾页面专用
export function GetToeflHearingPracticeReview(id) {
  return request({
    url: `toeflPractice3/${id}`,
    method: "GET"
  });
}

//查托福听力收藏
export function getToeflHearingCollection(id) {
  return request({
    url: `toeflHearingTextCollection/` + id,
    method: "GET"
  });
}

//取消托福听力我的标记部分的句子收藏
export function getMarkToeflHearingCollection(id) {
  return request({
    url: `toeflHearingTextCollection/` + id,
    method: "DELETE"
  });
}

//收藏托福句子
export function postToeflHearingCollection(data) {
  return request({
    url: `toeflHearingTextCollection`,
    method: "post",
    data
  });
}

//删除托福听力的句子收藏
export function delToeflHearingCollectionWord(data) {
  return request({
    url: `toeflHearingTextCollection/`,
    method: "DELETE",
    data
  });
}

// ---------- 托福听力题目 --------------

export function getToeflHearingText(id, state) {
  return request({
    url: `toeflHearingText/` + id + `?state=` + state,
    method: "get"
  });
}

//查托福听力历史记录
export function getToeflHearingHistoryText(id) {
  return request({
    url: `toeflHearingText2/` + id,
    method: "get"
  });
}

//托福听力查询收藏单词
export function getStudentHearingCollectionRecord(id, number) {
  return request({
    url: `studentCollectionRecord/5?toeflId=${id}`,
    method: "GET"
  });
}

//托福听力删除收藏单词 type5是收藏单词
export function delStudentHearingCollectionRecord(id, number) {
  return request({
    url: `studentCollectionRecord/5?toeflId=${id}&number=${number}`,
    method: "DELETE"
  });
}

//提交托福听力训练题目
export function postToeflTopic(data) {
  return request({
    url: `toeflPractice2`,
    method: "POST",
    data
  });
}
//托福阅读收藏题目
export function PostStudentCollectionRecord(data) {
  return request({
    url: `studentCollectionRecord`,
    method: "POST",
    data
  });
}
//托福阅读删除收藏题目
export function DeleteStudentCollectionRecord(id, number, state) {
  return request({
    url: `studentCollectionRecord/${state}?toeflId=${id}&number=${number}`,
    method: "DELETE"
  });
}
//托福阅读查询是否收藏过题目
export function GetStudentCollectionRecord(id, number, state) {
  return request({
    url: `studentCollectionRecord2/${state}?toeflId=${id}&number=${number}`,
    method: "GET"
  });
}
//托福阅读收藏题目列表
export function getStudentCollectionRecord(page, size, state, type, sort) {
  return request({
    url: `studentCollectionRecord/${state}?page=${page}&size=${size}&sort=${type},${sort}`,
    method: "GET"
  });
}
//收藏题目列表(新)
export function getToeflHearingCollectionRecord(type,distinguish,page, size, sort, wrong, questionType, review) {
  return request({
    url: `web/student/ieltsDeskmateCollect?${type?"type="+type:""}${distinguish?"&distinguish="+distinguish:''}&page=${page}&size=${size}&${sort}&wrong=${wrong}${questionType?'&questionType='+questionType:''}${review?'&review='+review:''}`,
    method: "GET"
  });
}
//修改错题本已复习状态
export function putToeflHearingCollectionRecord(data) {
  return request({
    url: `web/student/ieltsDeskmateCollect`,
    method: "PUT",
    data
  });
}
//收藏单词列表
export function getIeltsDeskmateCollect(type,distinguish,page, size, sort, wrong, studentWordName) {
  return request({
    url: `web/student/ieltsDeskmateCollect?${type?"type="+type:""}${distinguish?"&distinguish="+distinguish:''}&page=${page}&size=${size}&${sort}&wrong=${wrong}${studentWordName?'&studentWordName='+studentWordName:''}`,
    method: "GET"
  });
}
//删除收藏题目列表
export function deleteStudentCollectionRecordById(arr) {
  return request({
    url: `studentCollectionRecordById?ids=${arr}`,
    method: "DELETE"
  });
}
//删除收藏题目列表(新)
export function deleteieltsDeskmateCollectByIds(ids) {
  return request({
    url: `web/student/ieltsDeskmateCollectByIds/${ids}`,
    method: "DELETE"
  });
}
//添加/修改学生目标分数
export function postStudentTargetScore(data) {
  return request({
    url: `web/studentTargetScore`,
    method: "POST",
    data
  });
}
//查询学生目标分数
export function getStudentTargetScore(type) {
  return request({
    url: `web/studentTargetScore?type=${type}`,
    method: "GET"
  });
}

// 个人中心获取课程列表
export function studentCourseTimetable(courseTimetableStart) {
  return request({
    url:
      `web/studentCourseTimetable` +
      (courseTimetableStart
        ? `?courseTimetableStart=${courseTimetableStart}`
        : ""),
    method: "GET"
  });
}

//个人中心-我的课表 获取课程列表
export function studentCourseTimetableMyCourse(
  courseTimetableStart
) {
  return request({
    url:
    `web/studentCourseTimetable/days` +
      (courseTimetableStart
        ? `?courseTimetableStart=${courseTimetableStart}`
        : ""),
    method: "GET"
  });
}

// 查询学生绑定的科目及老师
export function studentClassSubject() {
  return request({
    url: `web/studentClassSubject`,
    method: "GET"
  });
}

// 查询所有科目list
export function queryUserClassSubject() {
  return request({
    url: `queryUserClassSubject`,
    method: "POST"
  });
}

// 查询学生的科目老师空闲时间（按老师约）
export function studentSubscribeClass(subjectId, type) {
  return request({
    url: `web/studentSubscribeClass/${subjectId}${
      typeof type === "string" ? "/" + type : ""
    }`,
    method: "GET"
  });
}

// 查询学生的科目老师空闲时间（按时间约）
export function studentSubscribeClassTeacher(time) {
  return request({
    url: `web/studentSubscribeClass/teacher${
      typeof time === "string" ? "?day=" + time : ""
    }`,
    method: "GET"
  });
}

// 查询体验课学生的科目老师空闲时间
export function experience(type, courseTimetableStart) {
  return request({
    url:
      `web/studentSubscribeClass/experience` +
      (typeof (type * 1) === "number" ? `?subjectId=${type}` : "") +
      (courseTimetableStart ? `&day=${courseTimetableStart}` : ""),
    method: "GET"
  });
}

// 查询用户套餐信息
export function userActivationType() {
  return request({
    url: `userActivationType`,
    method: "GET"
  });
}
//删除托福听力收藏题目
export function delStudentCollectionRecord(type, number, toeflId) {
  return request({
    url: `studentCollectionRecord/${type}?number=${number}&toeflId=${toeflId}`,
    method: "DELETE"
  });
}

//提交托福听力收藏题目  /提交雅思听力收藏题目
export function postStudentCollectionRecord(data) {
  return request({
    url: `studentCollectionRecord`,
    method: "POST",
    data
  });
}

//托福听力首页查询列表
export function getToeflIndexHearingList(front, after, afterText) {
  return request({
    url: `toeflHearingText/classify?front=${front}&after=${after}&afterText=${afterText}`,
    method: "GET"
  });
}

//托福听力详情页收藏题目
export function postToeflHearingCollectionRecord(data) {
  return request({
    url: `web/student/ieltsDeskmateCollect`,
    method: "POST",
    data
  });
}

//托福听力详情页删除题目
export function delToeflHearingCollectionRecord(id) {
  return request({
    url: `web/student/ieltsDeskmateCollect/${id}`,
    method: "DELETE"
  });
}

//查询听力模考列表--单科模考
export function getSingleMock(type, distinguish) {
  return request({
    url: `web/ieltsDeskmateBYLearning/${type}?distinguish=${distinguish}`,
    method: "GET"
  });
}

//查询单科模考的单科的数据
export function getSingleMockItem(ielts, test, typeId, distinguish, modeType = 1) {
  return request({
    url: `web/ieltsDeskmateByTest/${typeId}?ielts=${ielts}&test=${test}&distinguish=${distinguish}&modeType=${modeType}`,
    method: "GET"
  });
}

//雅思模考，单科模考听力题目提交
export function postSingleMockItem(type, data, distinguish) {
  return request({
    url: `web/ieltsDeskmateHearing/${type}?distinguish=${distinguish}`,
    method: "POST",
    data
  });
}

//雅思模考，单科模考作文提交
export function postSingleMockItemWriting(type, data, distinguish) {
  return request({
    url: `web/ieltsDeskmateWriting/${type}?distinguish=${distinguish}`,
    method: "POST",
    data
  });
}
//雅思模考，单科模考阅读提交
export function postSingleMockItemRead(type, data, ielts, test, distinguish) {
  return request({
    url: `web/ieltsDeskmateRead/${type}?ielts=${ielts}&test=${test}&distinguish=${distinguish}`,
    method: "POST",
    data
  });
}
//雅思模考，查答案的接口
export function getSingleMockAnswer(typeId, ielts, test, distinguish) {
  return request({
    url: `web/ieltsDeskmateAnswer/${typeId}?ielts=${ielts}&test=${test}&distinguish=${distinguish}`,
    method: "GET"
  });
}
//雅思模考，查答案的接口
export function delSingleMockAnswer(typeId, ielts, test, distinguish) {
  return request({
    url: `web/ieltsDeskmateAnswer/${typeId}?ielts=${ielts}&test=${test}&distinguish=${distinguish}`,
    method: "Delete"
  });
}


//雅思模考，查看阅读下面的按钮
export function getSingleMockReadingAnswer(ielts, test, distinguish) {
  return request({
    url: `web/ieltsDeskmateReadNumber?ielts=${ielts}&test=${test}&distinguish=${distinguish}`,
    method: "GET"
  });
}
// 雅思写作,按照剑雅顺序查询列表
export function getWritingListByOrder(ielts) {
  return request({
    url: `web/ieltsDeskmateWritingByIelts/${ielts}`,
    method: "GET"
  });
}
// 雅思写作,提交作业给做作业批改的功能使用
export function postWritingListByOrder(data) {
  return request({
    url: `teacher/web/studentWriting`,
    method: "POST",
    data
  });
}
// 雅思写作,提交作业给做作业批改的功能使用
export function postWritingListByOrder2(data) {
  return request({
    url: `web/student/studentAiWriting`,
    method: "POST",
    data
  });
}
export function postWritingListByOrder3(data) {
  return request({
    url: `web/student//studentAiWriting/3005`,
    method: "POST",
    data
  });
}

// 雅思写作,按照类别查Task1查询列表
export function getWritingListByType1(type) {
  return request({
    url: `web/ieltsDeskmateWritingBytask1?questionType=${type}`,
    method: "GET"
  });
}
// 雅思写作,按照类别查Task2查询列表
export function getWritingListByType2(questionType, theme) {
  return request({
    url: `web/ieltsDeskmateWritingBytask2?questionType=${questionType}&theme=${theme}`,
    method: "GET"
  });
}
//雅思写作,根据id查询题目详情
export function getWritingDetailsById(id) {
  return request({
    url: `web/ieltsDeskmateWritingById/${id}`,
    method: "GET"
  });
}
//雅思写作,提交写作答案
export function postWritingDetailsAnswer(id, data) {
  return request({
    url: `web/ieltsDeskmateWritingAnswer/${id}`,
    method: "POST",
    data
  });
}
//雅思写作,删除写作记录,清除答案
export function deleteWritingDetailsAnswer(id) {
  return request({
    url: `web/ieltsDeskmateWritingAnswer/${id}`,
    method: "DELETE"
  });
}

//雅思写作收藏
export function getWritingFavoriteAdd(id) {
  return request({
    url: `web/getStudentWritingFavoriteAdd/${id}`,
    method: "GET"
  });
}

//雅思写作删除收藏
export function getWritingFavoriteDel(id) {
  return request({
    url: `web/getStudentWritingFavoriteDel/${id}`,
    method: "GET"
  });
}

//雅思写作收藏列表
export function getWritingCollectionList() {
  return request({
    url: `web/getStudentWritingFavoriteList`,
    method: "GET"
  });
}

// 雅思口语，查询外层选项列表
export function ieltsDeskmateWritingByCondition(params) {
  return request({
    url: `web/ieltsDeskmateWritingByCondition`,
    method: "GET",
    params
  });
}

// 雅思口语，题目页面内容
export function getIeltsDeskmateOralById(id) {
  return request({
    url: `web/ieltsDeskmateOralById/${id}`,
    method: "GET"
  });
}

// 雅思口语，提交录音答案
export function postIeltsDeskmateOralById(id, data) {
  return request({
    url: `web/ieltsDeskmateOralAnswer/${id}`,
    method: "POST",
    data
  });
}

// 雅思口语，获取录音答案
export function getIeltsDeskmateOralAnswer(id) {
  return request({
    url: `web/ieltsDeskmateOralAnswer/${id}`,
    method: "GET"
  });
}

// 雅思口语，最新题库列表
export function postGetTraining(data) {
  return request({
    url: `/training/getTraining`,
    method: "POST",
    data
  });
}

// 雅思口语，最新题库题目列表
export function getTrainingList(ids, table) {
  return request({
    url: `/training/getTrainingList/${table}/${ids}`,
    method: "GET"
  });
}

// 雅思口语，最新题库获取历史答题
export function getTrainingHistory(ids, table) {
  return request({
    url: `training/getTrainingHistory/${table}/${ids}`,
    method: "GET"
  });
}

// 雅思口语，最新题库删除历史答题
export function getTrainingDelete(id, table) {
  return request({
    url: `training/getTrainingDelete/${table}/${id}`,
    method: "GET"
  });
}

// 雅思口语，最新题库文字题
export function postTrainingList(data) {
  return request({
    url: `training/postTrainingList`,
    method: "POST",
    data
  });
}

// 获取各个模块的table值
export function getListIssue() {
  return request({
    url: `training/getListIssue`,
    method: "GET"
  });
}

// 雅思口语，最新题库题目是否收藏
export function getTrainingListOne(id, table) {
  return request({
    url: `training/getTrainingListOne/${table}/${id}`,
    method: "GET"
  });
}

// 雅思口语，最新题库题目添加收藏
export function getTrainingFavoriteAdd(id, table) {
  return request({
    url: `training/getTrainingFavoriteAdd/${table}/${id}`,
    method: "GET"
  });
}

// 雅思口语，最新题库题目取消收藏
export function getTrainingFavoriteDel(id, table) {
  return request({
    url: `training/getTrainingFavoriteDel/${table}/${id}`,
    method: "GET"
  });
}
// 雅思口语，最新题库题目收藏的列表
export function getTrainingInfo(table) {
  return request({
    url: `training/getTrainingInfo/${table}`,
    method: "GET"
  });
}
// 阅读题库主页带连选接口（新）
export function ieltsReadClassify(type, cnTitle, questionType) {
  return request({
    url: `ieltsRead/classify?type=${type}${
      cnTitle ? "&cnTitle=" + cnTitle : ""
    }${questionType ? "&questionType=" + questionType : ""}`,
    method: "GET"
  });
}
// 阅读题库主页带连选接口（新2）
export function ieltsDeskmateReadClassify(ielts,cnTitle,questionType, modeType = 1) {
  ielts = ielts*1
  return request({
      url: `web/student/ieltsDeskmateRead/classify?${ielts?'&ielts='+ielts:''}${cnTitle != null?'&topic='+cnTitle:''}${questionType != null?'&questionType='+questionType:''}` + '&modeType=' + modeType,
      method: "GET"
  });
}
// 阅读题库题目页面接口（新）
export function getIeltsDeskmateRead(id) {
  return request({
      url: `web/student/ieltsDeskmateRead${id?'/'+id:''}`,
      method: "GET"
  });
}
// 阅读题库题目查询有多少题接口（新）
export function getIeltsDeskmateReadByNumber(id) {
  id = id*1
  return request({
      url: `web/student/ieltsDeskmateReadByNumber${id?'/'+id:''}`,
      method: "GET"
  });
}
// 阅读题库题目提交接口（新）
export function postIeltsDeskmateRead(state,data) {
  return request({
      url: `web/student/ieltsDeskmateRead${state?'/'+state:''}`,
      method: "POST",
      data
  });
}
// 听力题库主页带连选接口（新）
export function ieltsHearingClassify(type, section, questionType) {
  return request({
    url: `ieltsHearing/ieltsHearing/classify?type=${type}${
      section ? "&section=" + section : ""
    }${questionType ? "&questionType=" + questionType : ""}`,
    method: "GET"
  });
}

// 听力题库主页带连选接口（新）
export function getIeltsHearingClassify(ielts, topic, questionType, modeType = 1) {
  return request({
    url: `web/student/ieltsDeskmateHearing/classify?ielts=${ielts}${
      topic ? "&topic=" + topic : ""
    }${questionType ? "&questionType=" + questionType : ""}` + '&modeType=' + modeType,
    method: "GET"
  });
}

// 听力题库详情页查数据（新）
export function getIeltsHearingDetails(id) {
  return request({
    url: `web/student/ieltsDeskmateHearing/${id}`,
    method: "GET"
  });
}

//获取听力题目编号列表
export function getIeltsHearingQuestionList(id) {
  return request({
    url: `web/student/ieltsDeskmateHearingByNumber/${id}`,
    method: "GET"
  });
}

// 听力题库提交答案（新）
export function postIeltsHearingAnswer(state,data) {
  return request({
    url: `web/student/ieltsDeskmateHearing/${state}`,
    method: "POST",
    data
  });
}
//雅思听力重新答题删除答题记录
export function deleteListeningDetailsAnswer(id) {
  return request({
    url: `web/student/ieltsDeskmateHearing/${id}`,
    method: "DELETE"
  });
}

//get智能生成故事
export function getStory(text) {
  return request({
    url: `web/ai/getCompletion?text=${text}`,
    method: "GET",
  });
}
//保存智能生成的故事
export function postStory(data) {
  return request({
    url: `web/ai/saveStudentStory`,
    method: "POST",
    data
  });
}

//删除智能生成的故事
export function deleteStory(id) {
  return request({
    url: `web/ai/delStudentStory/${id}`,
    method: "DELETE"
  });
}

//获取智能生成的故事列表
export function getStoryList() {
  return request({
    url: `web/ai/getStudentStory`,
    method: "GET"
  });
}

//学生查询所有批改科目作业
export function getStudentCorrectHomework() {
  return request({
    url: `web/studentCorrectHomework`,
    method: "GET"
  });
}

//AI生成口语答案
export function postGenerateIeltsAnswers(data) {
  return request({
    url: `web/ai/generateIeltsAnswers`,
    method: "POST",
    data
  });
}

// 提交口语批改
export function postStudentTraining(data) {
  return request({
    url: `web/student/studentTraining`,
    method: "POST",
    data
  });
}

//查询剩余次数
export function getStudentTrainingNumber() {
  return request({
    url: `web/ai/getAiLimit`,
    method: "GET"
  });
}


//ai激活码激活次数接口
export function postAiActivationCodeDialog(data) {
  return request({
    url: `web/ai/postActivateStatus`,
    method: "POST",
    data
  });
}

//口语历史列表
export function getStudentTraining() {
  return request({
    url: `web/student/studentTraining`,
    method: "GET"
  });
}

//口语解析
export function getStudentTrainingId(id) {
  return request({
    url: `web/student/studentTraining/${id}`,
    method: "GET"
  });
}

//口语解析
export function getIeltsDeskmateWritingBytask(query) {
  return request({
    url: `web/ieltsDeskmateWritingBytask` + query,
    method: "GET"
  });
}

//获取登录验证码
export function postUserPhoneLoginCode(data) {
  return request({
    url: `web/userPhoneLoginCode`,
    method: "POST",
    data
  });
}

//手机号登录
export function postStudentPhoneLogin(data) {
  return request({
    url: `web/studentPhoneLogin`,
    method: "POST",
    data
  });
}

// 获取登录广告图片
export function getLoginImage() {
  return request({
    url: `web/loginImage`,
    method: "GET"
  });
}

// 上传自定义作业
export function postStudentWriting(data) {
  return request({
    url: `teacher/web/studentWriting`,
    method: "post",
    data
  });
}

// 作业提问
export function studentCorrectHomeworkQuestions(id, data) {
  return request({
    url: `web/studentCorrectHomework/questions/${id}`,
    method: "post",
    data
  });
}

// 作业批改评价
export function studentCorrectHomeworkEvaluate(id, data) {
  return request({
    url: `web/studentCorrectHomework/evaluate/${id}`,
    method: "post",
    data
  });
}


// 查询题目
export function getIeltsUploadQuestions(ieltsSubjectType, ielts, test, modeType = 1) {
  return request({
    url: `web/ieltsUploadQuestions?ieltsSubjectType=${ieltsSubjectType}&ielts=${ielts}&test=${test}&modeType=${modeType}`,
    method: "get"
  });
}

//  新增上传雅思答题卡
export function postIeltsSubmitAnswerSheet(data) {
  return request({
    url: `web/ieltsSubmitAnswerSheet`,
    method: "post",
    data
  });
}


//  获取答题卡
export function getIeltsSubmitAnswerSheet(parmas) {
  return request({
    url: `web/ieltsSubmitAnswerSheet?${parmas}`,
    method: "GET"
  });
}

//新版删除答题卡
export function deleteIeltsSubmitAnswerSheet(data) {
  return request({
    url: `web/ieltsSubmitAnswerSheet`,
    method: "DELETE",
    data
  });
}

// 新版加入错题本
export function postIeltsDeskmateCollect(data) {
  return request({
    url: `ieltsDeskmateCollect`,
    method: "post",
    data
  });
}

// 修改错题本
export function putIeltsDeskmateCollect(data) {
  return request({
    url: `ieltsDeskmateCollect`,
    method: "put",
    data
  });
}

// 新版删除错题本
export function deleteIeltsDeskmateCollect(id) {
  return request({
    url: `ieltsDeskmateCollect/${id}`,
    method: "delete"
  });
}

//获取口语AI次数
export function getGptNumberRefreshTime() {
  return request({
    url: `web/ai/getGptNumberRefreshTime`,
    method: "GET"
  });
}

//练习列表
export function getIeltsAcademic(modeType, ieltsSubjectType) {
  return request({
    url: `web/ieltsAcademic?modeType=${modeType}&ieltsSubjectType=${ieltsSubjectType}`,
    method: "GET"
  });
}

//获取简洁版 听力
export function ieltsDeskmateHearingClassifyAll(modeType, groupBy = 0) {
  return request({
    url: `/web/student/ieltsDeskmateHearing/classifyAll?modeType=${modeType}&groupBy=${groupBy}`,
    method: "GET"
  });
}

//获取简洁版 阅读
export function ieltsDeskmateReadClassifyAll(modeType, groupBy = 0) {
  return request({
    url: `/web/student/ieltsDeskmateRead/classifyAll?modeType=${modeType}&groupBy=${groupBy}`,
    method: "GET"
  });
}

// 写作批改重新提交
export function rePostStudentAiWriting(id) {
  return request({
    url: `web/student/studentAiWriting/3005/anew/${id}`,
    method: "post"
  });
}


// WEBPACK FOOTER //
// ./src/utils/api.js